import React from 'react';
import GlobalContext from '../GlobalContext';
import { VideoButton } from '../BFComponents';

const PDDetail = (props) => {
    console.log(props);
    if (Array.isArray(props.detailcolumns)) {
        return (
            <>
                <div className="card-deck">
                    {
                        props.detailcolumns.map(
                            (_item, _index) => (
                                <CanonDetailLayout rendercolor={props.rendercolor} header={_item.Header} detail={_item.Details} />
                            ))
                    }
                </div>
                <Logos videos={props.Videos} />
            </>
        );
    }

    return (<div className="container"><Logos /></div>)
}

const CanonDetailLayout = (props) => {
    const paths = GlobalContext().paths;
    const pictures = paths.pictures;

    const render_color = { backgroundColor: "#" + props.rendercolor };
    return (
        <div class="card addshadow" >
            <div id="canon-column-detail-header" style={render_color}>
                <div className="d-flex align-items-end">
                    <img className="canon-check" src={pictures + "check-mark.svg"}></img>
                    <h5>{props.header}</h5>
                </div>
            </div>
            <BulletPoint details={props.detail} />
        </div>
    )
}

const BulletPoint = (props) => {
    return (
        <ul className="canon-bullet-list">
            {
                props.details.map(
                    (_item, _index) => ( // Note: single line expression, so impilicit;y return our ItemComponent
                        <li className="bullet-point-text">{_item}</li>
                    ))
            }

        </ul>
    )
}

const Logos = (props) => {
    const paths = GlobalContext().paths;
    return (
        <>
            <div className="row">
                {
                    props.videos &&
                    props.videos.map(
                        (_item, _index) => ( // Note: single line expression, so impilicit;y return our ItemComponent
                            <div className="col-md-3">
                                <VideoButton id={_item.id} />
                            </div>
                        ))
                }
            </div>

            <div className="d-flex wrap" id="canon-logos-bottom">
                <div className="d-flex" >
                    <img src={paths.pictures + "canon-meap.svg"} className="canon-logos" />
                </div>
                <div className="d-flex">
                    <img src={paths.pictures + "canon-conservation.svg"} className="canon-logos" />
                </div>
                <div className="d-flex">
                    <img src={paths.pictures + "canon-genuine.svg"} className="canon-logos" />
                </div>
                <div className="d-flex">
                    <img src={paths.pictures + "canon-energy-star.svg"} className="canon-logos" />
                </div>
            </div>
        </>
    )
}

export default PDDetail;